import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, data) => {
	return fetch(
		Methods.PUT,
		`${EndPoints.COMPANIES_PONTO_ACCEPT_AGREEMENT}?companyId=${companyId}`,
		data,
		null,
		true
	);
};
